export const styles = {
  container: `flex flex-col h-0 flex-1 border-r border-gray-200 bg-white`,
  inner: `flex-1 flex flex-col pt-5 pb-4 overflow-y-auto`,
  logo: `flex items-center flex-shrink-0 px-4`,
  nav: `mt-5 flex-1 px-2 bg-white space-y-1`,
  footer: `flex-shrink-0 flex border-t border-gray-200 p-4`,
  navItemStandard: `text-gray-600 hover:text-gray-900 hover:bg-gray-50 group flex items-center px-2 py-2 text-sm font-medium rounded-md`,
  navItemActive: `bg-gray-100 text-gray-900 hover:bg-gray-100`
}
